const STORAGE_KEY = 'momentumeq_referral_code';
const EXPIRY_MS = 30 * 24 * 60 * 60 * 1000; // 30 days

interface StoredReferral {
  code: string;
  timestamp: number;
}

export function captureReferralCode(code: string): void {
  try {
    const data: StoredReferral = { code: code.toUpperCase(), timestamp: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // localStorage unavailable — no-op
  }
}

export function getStoredReferralCode(): string | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const data: StoredReferral = JSON.parse(raw);
    if (Date.now() - data.timestamp > EXPIRY_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return data.code;
  } catch {
    return null;
  }
}

export function clearStoredReferralCode(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    // no-op
  }
}
